import {applyTransaction, resetStores} from "@datorama/akita"
import API from "api/API"
import Logger from "logger/logger"
import {rootAuthPersistedStorage, rootAuthStore} from "store/auth/auth.store"

// These 3 functions are shared with the API class, therefor we keep them separate, since we will not be able to use
// any React hooks or similar functionality
function AuthApiService() {
  const logout = () => {
    Logger('Service.AuthApi.logout')
    API.post(`auth/logout`).then(() => {
      killSession()
    }).catch(() => {
      killSession()
    })
  }

  const refreshToken = async () => {
    Logger('Service.AuthApi.refreshToken')
    rootAuthStore.update(state => {
      state.isUpdatingToken = true
    })
    const get = await API.post('auth/token')
    applyTransaction(() => {
      rootAuthStore.update(state => {
        state.isUpdatingToken = false
        if (get.data.token)
          state.token = get.data.token
        else {
          state.token = ''
          state.isAuthenticated = false
        }
      })
    })
  }

  const killSession = () => {
    Logger('Service.AuthApi.killSession')
    resetStores({exclude: ['env']})
    rootAuthPersistedStorage.clearStore() // Clear persisted storage
  }

  return {
    logout,
    refreshToken,
    killSession
  }
}

export default AuthApiService
